import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBarsThree3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBarsThree3"><Path fillRule="evenodd" clipRule="evenodd" d="M2 5H22V6.5H2V5ZM2 11.25H14V12.75H2V11.25ZM2 17.5H22V19H2V17.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBarsThree3;
